/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetChangeRequestVisibilityAfterApprovalRequest
 */
export interface SetChangeRequestVisibilityAfterApprovalRequest {
    /**
     * 
     * @type {boolean}
     * @memberof SetChangeRequestVisibilityAfterApprovalRequest
     */
    storeProfileVisibilityAfterApproval: boolean;
}

/**
 * Check if a given object implements the SetChangeRequestVisibilityAfterApprovalRequest interface.
 */
export function instanceOfSetChangeRequestVisibilityAfterApprovalRequest(value: object): value is SetChangeRequestVisibilityAfterApprovalRequest {
    if (!('storeProfileVisibilityAfterApproval' in value) || value['storeProfileVisibilityAfterApproval'] === undefined) return false;
    return true;
}

export function SetChangeRequestVisibilityAfterApprovalRequestFromJSON(json: any): SetChangeRequestVisibilityAfterApprovalRequest {
    return SetChangeRequestVisibilityAfterApprovalRequestFromJSONTyped(json, false);
}

export function SetChangeRequestVisibilityAfterApprovalRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetChangeRequestVisibilityAfterApprovalRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'storeProfileVisibilityAfterApproval': json['storeProfileVisibilityAfterApproval'],
    };
}

export function SetChangeRequestVisibilityAfterApprovalRequestToJSON(json: any): SetChangeRequestVisibilityAfterApprovalRequest {
    return SetChangeRequestVisibilityAfterApprovalRequestToJSONTyped(json, false);
}

export function SetChangeRequestVisibilityAfterApprovalRequestToJSONTyped(value?: SetChangeRequestVisibilityAfterApprovalRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'storeProfileVisibilityAfterApproval': value['storeProfileVisibilityAfterApproval'],
    };
}

